/**
 * @generated SignedSource<<a454d36cf7514a40c42a62d7c99209bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QboPnlTagInputObject = {
  pnlLine: string;
  qboAccountId: string;
};
export type sourcesPage_TagsConfirmMutation$variables = {
  tags: ReadonlyArray<QboPnlTagInputObject>;
};
export type sourcesPage_TagsConfirmMutation$data = {
  readonly qboPnlTagsConfirm: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly ok: boolean;
  } | null | undefined;
};
export type sourcesPage_TagsConfirmMutation = {
  response: sourcesPage_TagsConfirmMutation$data;
  variables: sourcesPage_TagsConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tags"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "tags",
    "variableName": "tags"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_TagsConfirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QboPnlTagsConfirmMutationPayload",
        "kind": "LinkedField",
        "name": "qboPnlTagsConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourcesPage_TagsConfirmMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QboPnlTagsConfirmMutationPayload",
        "kind": "LinkedField",
        "name": "qboPnlTagsConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a95f72d367d2b9ed91a3569af055389",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_TagsConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_TagsConfirmMutation(\n  $tags: [QboPnlTagInputObject!]!\n) {\n  qboPnlTagsConfirm(tags: $tags) {\n    ok\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7df80194d2f6b55ef75b0c6bc7dd2231";

export default node;
